<mat-form-field class="example-full-width">
  <mat-select [(ngModel)]="filterId" [disabled]="!editMode">
    @for (filter of filters; track filter) {
      <mat-option [value]="filter.id" (onSelectionChange)="onSmartFilterChange(filter, $event, undefined)">
        <div class="option-content">
          {{ filter.name }}
          <i class="fas fa-info icon" [matTooltip]="filter.description"></i>
        </div>
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (selected) {
  <app-nested-panel-form-field
    [fields]="fields"
    [canAdd]="false"
    [editMode]="editMode"
    [fieldConfig]="selectedFieldConfig"
    [(formGroup)]="formGroup"
    [(data)]="smartFilterData"></app-nested-panel-form-field>
}
